var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames, entityTypeNameFor } from '@shapeable/utils';
import { groupBy, keyBy, map, mapValues } from 'lodash';
import { EntityDataGrid } from '../entities/entity-data-grid';
import { useDialogs } from '../hooks/use-dialogs';
var cls = classNames('form-field-number');
export var FormFieldLinkedJunctionDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var GridStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var isChromeless = _a.isChromeless;
    return isChromeless && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    "], ["\n    "])));
  })
});
var DialogStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Grid: styled(EntityDataGrid)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), GridStyles)
  // Dialog: styled(EntityTypeCreateForm)`${DialogStyles}`,
};
export var FormFieldLinkedJunction = function (props) {
  var className = props.className,
    value = props.value,
    data = props.data,
    entityTypeDefinition = props.entityTypeDefinition,
    isChromeless = props.isChromeless,
    supportingEntityTypeDefinitions = props.supportingEntityTypeDefinitions;
  // console.log("ENTITY TYPE DEFN", entityTypeDefinition);
  // console.log("SUPPORTING ENTITY TYPE DEFNS", supportingEntityTypeDefinitions);
  // console.log("DATA", data);
  var dialogs = useDialogs();
  var handleRemoveClick = function (entity) {
    // dialogs.push(
    //   <EntityDeleteDialog entity={entity} />
    // );
  };
  var handleAddClick = function (entityTypeName) {
    return function (event) {
      return __awaiter(void 0, void 0, void 0, function () {
        var EntityCreateDialog;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              event.preventDefault();
              event.stopPropagation();
              return [4 /*yield*/, import('../entities/entity-create-dialog')];
            case 1:
              EntityCreateDialog = _a.sent().EntityCreateDialog;
              dialogs.push(React.createElement(EntityCreateDialog, {
                entityType: entityTypeName
              }));
              return [2 /*return*/];
          }
        });
      });
    };
  };
  var itemsByEntityTypeName = groupBy(data, function (entity) {
    return entityTypeNameFor(entity);
  });
  if (!data.length && supportingEntityTypeDefinitions) {
    /* @ts-ignore */
    itemsByEntityTypeName = mapValues(keyBy(supportingEntityTypeDefinitions, 'name'), function (defn) {
      return [];
    });
  }
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, map(itemsByEntityTypeName, function (items, entityTypeName) {
    var supportingEntityTypeDefinition = supportingEntityTypeDefinitions[entityTypeName];
    if (supportingEntityTypeDefinition) {
      return React.createElement(My.Grid, {
        isChromeless: isChromeless,
        showBorder: !isChromeless,
        key: entityTypeName,
        items: items,
        onAddClick: handleAddClick(entityTypeName),
        onRemoveClick: handleRemoveClick,
        defn: supportingEntityTypeDefinition
      });
    }
    return null;
  }));
};
FormFieldLinkedJunction.cls = cls;
FormFieldLinkedJunction.defaultProps = FormFieldLinkedJunctionDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;